module.exports = new __parcel__URL__("highest-priority.32f80175.svg").toString();